import { useState } from 'react';
import { api } from '@gtintel/platform-api';
import { RequestEditorContext } from '../../ProjectApp/context';
// this is to use the new Partner search box in the quality app - the features there will eventually live in the request editor so this is a temporary 👃 solution

export const RequestEditorForMatchingProvider = ({
  children
}) => {
  const [selectedPartner, setSelectedPartner] = useState(undefined);
  const requestEditorCtx = {
    requestId: () => '',
    isSent: () => false,
    searchPartners: async (q, is_qa) => {
      let search;
      if (is_qa) {
        search = await api.project.searchQaPartners(q);
      } else {
        search = await api.project.searchPartners(q);
      }
      return search.data.matches;
    },
    setPartner: async partner => setSelectedPartner(partner),
    partner: () => selectedPartner,
    report: () => undefined,
    fullReport: () => undefined,
    selectedScope: () => undefined,
    selectionState: () => undefined,
    toggleSelected: () => undefined,
    isScopeSelected: () => undefined,
    setDraft: () => undefined,
    send: () => undefined,
    assign: () => undefined,
    cancel: () => undefined,
    unsubmit: () => undefined,
    submit: () => undefined,
    decline: () => undefined,
    accept: () => undefined,
    status: () => undefined,
    toggleFinished: async () => {},
    fee: () => undefined,
    dueDate: () => undefined,
    acceptedDate: () => null,
    activatedDate: () => null,
    declinedDate: () => null,
    cancelledDate: () => null,
    submittedDate: () => null,
    finishedDate: () => null,
    investigatorNotes: () => '',
    currency: () => null,
    setFee: async _ => {},
    setDueDate: async _ => {},
    proposedPartners: () => [],
    addProposedPartners: partners => {},
    id: () => null,
    name: () => null,
    setName: async name => {},
    isQaAssignment: () => false,
    setIsQaAssignment: async value => {},
    isLeadPartnerAssignment: () => false
  };
  return <RequestEditorContext.Provider value={requestEditorCtx}>
      {children}
    </RequestEditorContext.Provider>;
};